import { config } from './config';

export async function trackGeneralFeedback(productLink, feedback, sessionId, customerId, website) {
    const url = `${config.BASE_URL}/track/feedback`;
    const userAgent = navigator.userAgent;

    const intFeedbackValue = parseInt(feedback);
    
    const body = {
        ft: 'general_V01',
        fv: intFeedbackValue,
        site: website,
        c_id: customerId,
        url: productLink,
        ua: userAgent,
        se_id: sessionId
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });

    return response;
}